import { Route, Routes } from 'react-router-dom';

import LoginPage from 'pages/hotaiCallback/Login';
import LoginCallbackPage from 'pages/hotaiCallback/LoginCallback';
import CustomerRelaxRgister from 'pages/lexusOfficialAccount/CustomerRelaxRegister';
import LoginLineCallbackPage from 'pages/lexusOfficialAccount/LineLoginComplete';
import LexusPostbackPage from 'pages/lexusOfficialAccount/LexusPostback';
import LexusCalenderPage from 'pages/lexusOfficialAccount/LexusCalendar';
import LexusStartServicePage from 'pages/lexusOfficialAccount/LexusStartService';
import LexusReurlPage from 'pages/lexusOfficialAccount/LexusReurl';
import LexusLoungePage from 'pages/lexusOfficialAccount/LexusLounge';
import LexusPnpPage from 'pages/lexusOfficialAccount/pnp/LexusPnp';
import LexusServiceNews from 'pages/lexusOfficialAccount/LexusServiceNews';
import Error404 from 'pages/errorPages/Error404';
import PnpWebviewRouter from 'router/pnpWebview/PnpWebviewRouter';
import ToyotaRouter from './ToyotaRouter';

const CallbackRouter = () => {
  return (
    <Routes>
      <Route path="/lexus" element={<LexusStartServicePage />}></Route>
      <Route path="/login" element={<LoginPage />}></Route>
      <Route path="/callback/login" element={<LoginCallbackPage />}></Route>
      <Route path="/reurl/*" element={<LexusReurlPage />}>
        <Route path=":reurlType" element={<LexusReurlPage />}></Route>
      </Route>
      <Route path="/postback" element={<LexusPostbackPage />}></Route>
      <Route path="/serviceNews" element={<LexusServiceNews />}></Route>
      <Route path="/calendar" element={<LexusCalenderPage />}></Route>
      <Route
        path="/login/line/complete"
        element={<LoginLineCallbackPage />}></Route>
      <Route
        path="/customizedService/lounge"
        element={<LexusLoungePage />}></Route>
      <Route
        path="/customizedService/station/:stationId/customerRelax"
        element={<CustomerRelaxRgister />}></Route>
      <Route path="/lexus/pnp" element={<LexusPnpPage />}></Route>
      <Route path="/lexus/pnp/*" element={<PnpWebviewRouter />}></Route>
      <Route path="/toyota/*" element={<ToyotaRouter />}></Route>
      <Route path="*" element={<Error404 />}></Route>
    </Routes>
  );
};

export default CallbackRouter;
